<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Cxy3Xv/tc-custom/9781504016537.jpg?1704919349159" alt="This image is the cover for the book Sherlock Holmes and the Seven Deadly Sins Murders"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Sherlock Holmes and the Seven Deadly Sins Murders
      </h1>
      <p class="bookDescription body article font2">
        <b>The members of an old Oxford club are targeted, and Mycroft Holmes may be the next victim: “[Day]</b><b>always captures the flavor of Conan Doyle” (<i>The Sherlockian Times</i>).</b><br/><br/> Six months after the bloody return of Jack the Ripper, Sherlock Holmes is starved for entertainment. When a friend of Dr. Watson’s suggests a shooting trip in Scotland, Holmes leaps at the invitation. But after nearly a week of dreary Scottish weather, and hardly any shooting at all, Holmes is worse off than before. Watson fears the holiday has been an utter bust—until they are confronted with a murder baffling enough to be worthy of the great detective.<br/>  <br/> One of the local gentry has been found dead in his library, suffocated in the safe where he kept his most valuable documents. Holmes recognizes the dead man as a member of the same secret society as his brother Mycroft—the Oxford group known as the Seven Sinners. One sinner down, six to go . . . but if Mycroft falls, so does England, and Holmes must be quick in order to save both his brother and his country.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Barry Day
      </h2>
      
      <p class="authorDescription body article">Barry Day is an author, scholar, and expert on legendary playwright No&euml;l Coward. Born in England, Day was educated at Oxford and made his name writing impeccably researched books on legendary wits Dorothy Parker, Oscar Wilde, and P.&#160;G. Wodehouse. In addition to producing a series of mysteries featuring Sherlock Holmes, Day wrote the book considered to be the definitive Holmes biography, <I>Sherlock Holmes: In His Own Words and the Words of Those Who Knew Him. </I>He is also the editor of the essential <I>The Letters of No&euml;l Coward</I>.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?189ba4eb